class IBANFinder{
    constructor(ibanFinders){
        this.ibanFinders = document.getElementById(ibanFinders);
        this.init();

    }
    init(){
        if(this.ibanFinders){

            let reset = this.ibanFinders.querySelector('#reset')
            reset.addEventListener('click',()=>this.clearbox())
            let validate = this.ibanFinders.querySelector('#validate_iban')
            validate.addEventListener('click',()=>this.generate_iban())
        }
    }
     trimReplace(stringToTrim) {
        return stringToTrim.replace(/^\s+|\s+$/g, "");
    }

     generate_iban() {
        //$(".errmsg").remove();
        $('#iban-answer').hide();
        $('#iban-error').hide();
        $('#iban_control_id').val("");
        var adib_account_no = $('#account_number_control_id').val();
    
        if (this.trimReplace(adib_account_no) == '') {
            $('#iban-error').text(this.ibanFinders.getAttribute("data-error-invalidAccount"));
            $('#iban-error').show();
        
            return false;
        }
        else {

            var account_no = this.trimReplace(adib_account_no);
            var digit = /^\d+$/;
            if (account_no.length == 8 || account_no.length == 16) {
                if (!digit.test(account_no)) {
                    $('#iban-error').text(this.ibanFinders.getAttribute("data-error-invalidAccount"));
                    $('#iban-error').show();
                   
                    return false;
                }
                else {
                    CreateIBAN("iban_control_id", "account_number_control_id");
                    $('#iban-answer').text(this.ibanFinders.getAttribute("data-successmsg"));
                    $('#iban-answer').show();
                    
                }
            } else {
                $('#iban-error').text(this.ibanFinders.getAttribute("data-error-accountlength"));
                
                $('#iban-error').show();
            
                return false;
            }
        }
        // gtagCalculatorIBANFinder();
    }
    
     clearbox(){
    //alert('Hi');
    $('#account_number_control_id').val("");
    $('#iban_control_id').val("");
    //$('.errmsg').html('');

    $('#iban-answer').text("");
    $('#iban-error').text("");
    $('#iban-error').hide();
    $('#iban-answer').hide();
    }
}
export default IBANFinder